import React, {useEffect, useState} from "react";
import axios from "axios";
import { useHistory, useParams, Link } from "react-router-dom";
import Header from "../../common/Header";
import SideBar from "../../common/SideBar";
import AuditTrail from "../projectScripts/AuditTrail";
import Swal from "sweetalert2";
import { usePermissionGuardRedirect } from "../../../hooks/usePermissionGuard";
import PCProjectDetails from "./PCProjectDetails";
import PCProjectNotes from "./PCProjectNotes";
import {
  GetPCProject
} from "../../../services/ProjectCenterServices";
function PCProjectOpenWrapper() {
  const history = useHistory();
  const { type, id } = useParams();
  const [loading, setLoading] = useState(Boolean(id));
  const [projectName, setProjectName] = useState(null);
  const [reload, setReload] = useState(false);
  const [projectDetails, setProjectDetails] = useState(null);
  usePermissionGuardRedirect(
    type === "open" || type == 'audittrail' ? ["projectcenterprojectsview"] : ["projectcenterprojectsadd"]
  );
    useEffect(() => {
    if (!id) return;

    const source = axios.CancelToken.source();

      const getProject = async () => {
        setLoading(true);
        try {
          const res = await GetPCProject(id, source.token);
          if (res.status === 200) {
            setProjectName(res?.data?.data?.name);
            setProjectDetails(res?.data?.data);
          }
        } catch (error) {
          if (!axios.isCancel(error)) {
            console.error(error);
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "Unable to load project",
            });
          }
        } finally {
          setLoading(false);
        }
      };
      if (Boolean(id) && id > 0) {
        getProject();
      }

      return () => {
        source.cancel("Component unmounted");
      };
    }, [id, reload]);

  return (
    <>
      <Header />
      <div className="content-wrapper d-flex flex-wrap">
        <SideBar />
        <div className="sidebar-right">
          <div className="sub-menu-content-block">
            <div className="sub-menu-right-block">
              <div className="wrap-box-right">
                <div className="my-tickets-heading-blk flex-direction mb-2">
                  <div className="d-flex align-items-center ">
                    <div className="name-w-head d-flex align-items-center">
                      <h4 className="text-left-align landing-heading heading_color_dynamic">
                        Project {projectName ? <> Project: <span>{projectName}</span></> : <span>Project</span>}
                      </h4>
                    </div>

                    <div className="text-md-right action2-blk">
                      <div className="ticket-view-btn d-flex align-items-center">
                        <div className="add-new-ticket-bx">
                          <button
                            onClick={() => history.goBack()}
                            title="Back"
                            className="btn btn-white-bordered"
                          >
                            <i className="fal fa-angle-left"></i>Back
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="tabs-wrap">
                  {(type === "open" || type === "audittrail" || type === "notes") && (
                    <ul className="nav nav-pills mb-4" id="tabs" role="tablist">
                      <li
                        className="nav-item"
                        onClick={() =>
                          history.push(`/project-center/projects/open/${id}`)
                        }
                      >
                        <Link
                          className={`nav-link ${type === "open" && "active"}`}
                          id="pills-tab1"
                          data-toggle="pill"
                          to={`/project-center/projects/open/${id}`}
                          role="tab"
                          aria-controls="pills-tab11"
                          aria-selected="true"
                          title="Project Details"
                        >
                          <i className="fa fa-info-circle"></i>
                          Details
                        </Link>
                      </li>
                      <li
                        className="nav-item"
                        onClick={() =>
                          history.push(`/project-center/projects/notes/${id}`)
                        }
                      >
                        <Link
                          className={`nav-link ${type === "notes" && "active"}`}
                          id="pills-tab1"
                          data-toggle="pill"
                          to={`/project-center/projects/notes/${id}`}
                          role="tab"
                          aria-controls="pills-tab11"
                          aria-selected="true"
                          title="Project Details"
                        >
                          <i className="fa fa-info-circle"></i>
                          Notes
                        </Link>
                      </li>
                      <li
                        className="nav-item"
                        onClick={() =>
                          history.push(`/project-center/projects/audittrail/${id}`)
                        }
                      >
                        <Link
                          className={`nav-link ${type === "audittrail" && "active"}`}
                          id="pills-tab2"
                          data-toggle="pill"
                          to={`/project-center/projects/audittrail/${id}`}
                          role="tab"
                          aria-controls="pills-tab12"
                          aria-selected="true"
                          title="Audit trail"
                        >
                          <i className="fal fa-history"></i>Audit trail
                        </Link>
                      </li>
                    </ul>
                  )}

                  <div className="tab-content" id="pills-tabContent">
                    <div
                      className="tab-pane fade active show"
                      id="pills-tab11"
                      role="tabpanel"
                      aria-labelledby="pills-tab1"
                    >
                      {type === "open" && <PCProjectDetails 
                      id={id}
                      projectDetails={projectDetails}
                      loading={loading}
                      setLoading={setLoading}
                      setReload={setReload} 
                      reload={reload}
                      />}
                      {
                        type === "notes" && <PCProjectNotes 
                        id={id}
                        projectDetails={projectDetails}
                        loading={loading}
                        setLoading={setLoading}
                        setReload={setReload} 
                        reload={reload}
                        />
                      }
                      {type  === "audittrail" && <AuditTrail id={id} entityType="projects" />}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PCProjectOpenWrapper;